import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import affiliationService from "~/modules/relation/affiliation/services/affiliation.service";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";

export function useGetAffiliationParent(params: GenericParameters) {
  const service =
    affiliationService.getOrganizationAffiliationParent.bind(
      affiliationService,
    );

  const isLoading = ref<boolean>(false);
  const error = ref<LxcError | undefined>();
  const result: Ref<RelationEntity | undefined> = ref<
    RelationEntity | undefined
  >(undefined);

  async function getAffiliationParent(): Promise<void> {
    isLoading.value = true;

    error.value = undefined;
    result.value = undefined;

    const response = await service(params);

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    getAffiliationParent,
    error,
    isLoading,
    result,
  };
}
